import * as types from '@store/mutation-types'

// initial state
// shape: [{ id, quantity }]
const state = {
  userOptions: [],
  options: {
    status: [
      {label: '待验证', value: 0},
      {label: '已验证', value: 1},
      {label: '阶段封号', value: -1},
      {label: '永久封号', value: -2},
    ],
    currentstatus: [
      {label: '未激活', value: 0},
      {label: '活跃', value: 1},
      {label: '待机', value: 3},
      {label: '未转化', value: 4},
    ],
    level: [
      {label: '铁牌', value: 0},
      {label: '铜牌', value: 1},
      {label: '银牌', value: 2},
      {label: '金牌', value: 3},
      {label: '铂金', value: 4},
      {label: '钻石', value: 5},
    ],
    believable: [
      {label: '不可信', value: 0},
      {label: '可信', value: 1},
    ],
    type: [
      {label: '店内员工', value: 11},
      {label: '销售与督导', value: 12},
      {label: '其他', value: 13},
      {label: 'SJF销售', value: 90},
    ],
    bankcardverified: [
      {label: '未验证', value: 0},
      {label: '已验证', value: 1},
    ],
    idnumverified: [
      {label: '未验证', value: 0, color: '#333333'},
      {label: '待完善', value: 1, color: '#999999'},
      {label: '已验证', value: 2, color: '#67C23A'},
      {label: '验证失败', value: 3, color: '#F56C6C'},
    ],
    zfb_accountverified: [
      {label: '未验证', value: 0},
      {label: '已验证', value: 1},
    ],
    workinfoStatus: [
      {label: '待完善', value: 0},
      {label: '待审核', value: 1},
      {label: '审核通过', value: 2},
      {label: '审核不通过', value: 3},
      {label: '已过期', value: 4},
    ],
    provinces: [],
    abilities: [],
    attributes: [],
    work_type: [],
    business_type: [],
    business_work_type: [],
    is_forbidden_withdraw: [
      {label: '否', value: 0},
      {label: '是', value: 1},
    ],
    register_app_type: [
      {label: '爱零工', value: 1},
      {label: '查理宝', value: 2},
      {label: '主平台', value: 3},
    ],
  },
  deviceDetailFields: [
    { prop: 'id', label: 'ID' },
    { prop: 'devicenum', label: '设备号' },
    { prop: 'userid', label: '用户ID' },
    { prop: 'realname', label: '真实姓名' },
    { prop: 'province_name', label: '省份' },
    { prop: 'city_name', label: '城市' },
    { prop: 'area_name', label: '地区' },
    { prop: 'user_is_blocked', label: '是否被封号', formatter: (row) => row.user_is_blocked === true ? '是' : '否' },
    { prop: 'user_is_exclusive', label: '是否独占标签', formatter: (row) => row.user_is_exclusive === true ? '是' : '否' },
    { prop: 'user_is_unregister', label: '是否注销', formatter: (row) => row.user_is_unregister === true ? '是' : '否' },
    { prop: 'last_login_at', label: '最后登录时间' },
    { prop: 'app_type', label: '登录App', formatter: (row) => Number(row.app_type) === 1 ? '爱零工' : '查理宝' },
  ],
  deviceDetailExportFields: [
    { prop: 'id', label: 'ID' },
    { prop: 'devicenum', label: '设备号' },
    { prop: 'userid', label: '用户ID' },
    { prop: 'realname', label: '真实姓名' },
    { prop: 'province_name', label: '省份' },
    { prop: 'city_name', label: '城市' },
    { prop: 'area_name', label: '地区' },
    { prop: 'cellphone', label: '手机号' },
    { prop: 'strcurrentstatus', label: '用户当前状态' },
    { prop: 'registertime', label: '注册时间' },
    { prop: 'cumulative_bounty', label: '累计赏金' },
    { prop: 'balance', label: '账户余额' },
    { prop: 'business_type', label: '行业' },
    { prop: 'work_type', label: '工种' },
    { prop: 'belongto', label: '公司名称' },
    { prop: 'main_brand', label: '主营品牌' },
    { prop: 'workinfo_status_cn', label: '职业信息状态' },
    { prop: 'last_login_at', label: '最后登录时间' },
    { prop: 'user_is_blocked', label: '是否被封号', formatter: (row) => row.user_is_blocked === true ? '是' : '否' },
    { prop: 'user_is_exclusive', label: '是否独占标签', formatter: (row) => row.user_is_exclusive === true ? '是' : '否' },
    { prop: 'user_is_unregister', label: '是否注销', formatter: (row) => row.user_is_unregister === true ? '是' : '否' },
    { prop: 'app_type', label: '登录App', formatter: (row) => Number(row.app_type) === 1 ? '爱零工' : '查理宝' },
  ],
  riskusersOpts: {
    riskStatusOpts: {
      1: '风险用户',
      2: '正常用户',
    },
    riskConfirmStatusOpts: {
      1: '待确认',
      2: '无需确认',
      3: '确认风险',
      4: '确认正常',
    }
  }
}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getUserDetail ({commit, state}, id) {
    let promised = request.alert('getUserDetail', id)
    return promised
  },
  getUserRelatedOptions ({commit, state}, params) {
    let promised = request.page('getUserRelatedOptions', params)
    promised.then((res) => {
      commit(types.SET_USER_RELATED_OPTIONS, res.data)
    }, Function.prototype)
    return promised
  },
  getQueryCustomerService ({commit, state}, params) {
    let promised = request.alert('getQueryCustomerService', params)
    return promised
  },
  addCustomerService ({commit, state}, params) {
    let promised = request.alert('addCustomerService', params)
    return promised
  },
  modifyCustomerService ({commit, state}, params) {
    let promised = request.alert('modifyCustomerService', params)
    return promised
  },
  getUserDevice ({commit, state}, id) {
    let promised = request.alert('getUserDevice', id)
    return promised
  },
  getUserOperate ({commit, state}, id) {
    let promised = request.alert('getUserOperate', id)
    return promised
  },
  getUserAccount ({commit, state}, id) {
    let promised = request.alert('getUserAccount', id)
    return promised
  },
  getUserLog ({commit, state}, id) {
    let promised = request.alert('getUserLog', id)
    return promised
  },
  getUserCredit ({commit, state}, id) {
    let promised = request.alert('getUserCredit', id)
    return promised
  },
  getCreditList ({commit, state}, params) {
    let promised = request.alert('getCreditList', params)
    return promised
  },
  getPointList ({commit, state}, params) {
    let promised = request.alert('getPointList', params)
    return promised
  },
  getUserPoints ({commit, state}, id) {
    let promised = request.alert('getUserPoints', id)
    return promised
  },
  getMasTable ({commit, state}, id) {
    let promised = request.alert('getMasTable', id)
    return promised
  },
  getCityList ({commit, state}, id) {
    let promised = request.alert('getCityList', id)
    return promised
  },
  getProvinceList ({commit, state}, params) {
    let promised = request.alert('getProvinceList', params)
    return promised
  },
  getMarketInfo ({commit, state}, params) {
    let promised = request.alert('getMarketInfo', params)
    return promised
  },
  getTagInfo ({commit, state}, params) {
    let promised = request.alert('getTagInfo', params)
    return promised
  },
  uploadUserMasImg ({commit, state}, params) {
    let promised = request.alert('uploadUserMasImg', params)
    return promised
  },
  addUserMas ({commit, state}, params) {
    let promised = request.alert('addUserMas', params)
    return promised
  },
  getUserMasDetail ({commit, state}, id) {
    let promised = request.alert('getUserMasDetail', id)
    return promised
  },
  getAreaList ({commit, state}, id) {
    let promised = request.alert('getAreaList', id)
    return promised
  },
}

// mutations
const mutations = {
  [types.SET_USER_RELATED_OPTIONS] (state, data) {
    state.userOptions = data
  },
  [types.SET_USER_OPTIONS] (state, data) {
    filter.setLoop(state.options, data)
  },
}

export const users = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/users/users.store.js